import React, {useState, useEffect, useRef} from 'react';
import { Formik, Field, Form } from 'formik';
import axios, { AxiosRequestHeaders } from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import ConfirmationModal from '../../shared/ConfirmationModal';
import NewconfirmationModal from '../../shared/NewconfirmationModal';
import AllFailureModal from '../../shared/AllFailureModal';

interface CompaniesFormValues {
  company_id: string;
  company_name: string;
  team_size: number;
  email: string;
  established_in: string;
  contact_number: string;
  primary_industry: string;
  company_website: string;
  comp_registration_number: string;
  about_company: string;
  city: string;
  address: string;
  facebook: string;
  twitter: string;
  linkedin: string;
  whatsapp: string;
  instagram: string;
  pinterest: string;
  working_days: string;
  working_hours: string;
  tagline: string;
  logo: File | null;
}

interface Industry {
  id: number;
  name: string;
}

interface User {
  id: number;
  name: string;
  usertype: string;
  company_id: string;
}

const CompaniesAdd = () => {
  const initialValues: CompaniesFormValues = {
    company_id: '',
    company_name: '',
    team_size: 0,
    email: '',
    established_in: '',
    contact_number: '',
    primary_industry: '',
    company_website: '',
    comp_registration_number: '',
    about_company: '',
    city: '',
    address: '',
    facebook: '',
    twitter: '',
    linkedin: '',
    whatsapp: '',
    instagram: '',
    pinterest: '',
    working_days: '',
    working_hours: '',
    tagline: '',
    logo: null,
  };

  // const [modalShow, setModalShow] = useState(false);
  // const [modalMessage, setModalMessage] = useState('');
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [failureMessage, setFailureMessage] = useState('');
  const [industries, setIndustries] = useState<Industry[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);
  const [searchTerm2, setSearchTerm2] = useState<string>("");
  const [isDropdownOpen2, setIsDropdownOpen2] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const headers: AxiosRequestHeaders = {
    'x-access-token': localStorage.getItem('jwttoken') || '',
  };

  const navigate = useNavigate();
  const filteredIndustries = industries.filter((industry) =>
    industry.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const filteredEmployers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm2.toLowerCase())
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<any>(`${process.env.REACT_APP_API_URL}users/employers`, { headers });
        setUsers(response.data.employers || response.data);

        const industriesResponse = await axios.get<Industry[]>(`${process.env.REACT_APP_API_URL}industries/get-all-industries`);
        setIndustries(industriesResponse.data);

      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)){
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    }
  }, []);


  const addNewCompanies = async (values: CompaniesFormValues) => {
    setShowConfirmationModal(true);
    try {
      const url = process.env.REACT_APP_API_URL + 'companyDetails/createcompany';
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (key !== 'logo') {
          formData.append(key, values[key as keyof CompaniesFormValues]?.toString() || '');
        }
      });

      if (values.logo) {
        formData.append('logo', values.logo);
      }

      const response = await axios.post(url, formData);
      return { success: true };
    } catch (error) {
      console.log('Error adding Companies:', error);
      return { success: false };
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Create New Company</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={initialValues}
                onSubmit={async (values: CompaniesFormValues, { resetForm }) => {
                  const result = await addNewCompanies(values);
                  if (result.success) {
                    setSuccessMessage("Employer profile created successfully.");
                    setShowSuccessModal(true);
                    resetForm();
                  } else {
                    setFailureMessage("Error adding company. Please try again.");
                    setShowFailureModal(true);
                  }
                }}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Company Name:<span className="text-danger">*</span></label>
                          <Field name="company_name">
                            {({ field, form }: { field: any; form: any }) => (
                              <div className="dropdown">
                                <input
                                  type="text"
                                  placeholder="Search Company"
                                  value={searchTerm2}
                                  onChange={(e) => {
                                    setSearchTerm2(e.target.value);
                                    setIsDropdownOpen2(!!e.target.value);
                                  }}
                                  onFocus={() => setIsDropdownOpen2(!!searchTerm2)}
                                  className="form-control mb-3"
                                  required
                                />
                                {isDropdownOpen2 && searchTerm2 && (
                                  <div className="dropdown-menu show w-100">
                                    {filteredEmployers.length > 0 ? (
                                      filteredEmployers.map((user) => (
                                        <div
                                          key={user.id}
                                          className="dropdown-item cursor-pointer"
                                          onClick={() => {
                                            form.setFieldValue(field.name, user.name);
                                            setSearchTerm2(user.name);
                                            form.setFieldValue('company_id', user.company_id)
                                            setIsDropdownOpen2(false);
                                          }}
                                        >
                                          {user.name}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="dropdown-item no-results">No results found</div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Email:<span className="text-danger">*</span></label>
                          <Field
                            type="email"
                            name="email"
                            className="form-control mb-3"
                            placeholder="Enter Email"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Contact Number:<span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="contact_number"
                            className="form-control mb-3"
                            placeholder="Enter Contact Number"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Registration Number:<span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="comp_registration_number"
                            className="form-control mb-3"
                            placeholder="Enter Registration Number"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Website:<span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="company_website"
                            className="form-control mb-3"
                            placeholder="Enter Website URL"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Team Size:</label>
                          <Field
                            type="text"
                            name="team_size"
                            className="form-control mb-3"
                            placeholder="Enter Team Size"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Established Year:</label>
                          <Field
                            type="text"
                            name="established_in"
                            className="form-control mb-3"
                            placeholder="Enter Established Year"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Primary Industry:<span className="text-danger">*</span></label>
                          <Field name="primary_industry">
                            {({ field, form }: { field: any; form: any }) => (
                              <div className="dropdown" ref={dropdownRef}>
                                <input
                                  type="text"
                                  placeholder="Search Industry"
                                  value={searchTerm}
                                  onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setIsDropdownOpen(!!e.target.value);
                                  }}
                                  onFocus={() => setIsDropdownOpen(true)}
                                  className="form-control mb-3"
                                  required
                                />
                                {isDropdownOpen && (
                                  <div className="dropdown-menu show w-100" style={{ maxHeight: "250px", overflowY: "auto" }}>
                                    {filteredIndustries.length > 0 ? (
                                      filteredIndustries.map((industry) => (
                                        <div
                                          key={industry.id}
                                          className="dropdown-item cursor-pointer"
                                          onClick={() => {
                                            form.setFieldValue(field.name, industry.name);
                                            setSearchTerm(industry.name);
                                            setIsDropdownOpen(false);
                                          }}
                                        >
                                          {industry.name}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="dropdown-option no-results">No results found</div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </Field>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Working Days:</label>
                          <Field
                            type="text"
                            name="working_days"
                            className="form-control mb-3"
                            placeholder="Enter Working Days"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Working Hours:</label>
                          <Field
                            type="text"
                            name="working_hours"
                            className="form-control mb-3"
                            placeholder="Enter Working Hours"
                            required
                          >
                          </Field>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-full">
                        <div className="form-group">
                          <label className="form-label">About Company:<span className="text-danger">*</span></label>
                          <Field
                            as="textarea"
                            name="about_company"
                            className="form-control mb-3"
                            rows="5"
                            placeholder="Enter a detailed company description..."
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-full">
                        <div className="form-group">
                          <label className="form-label">Full Address:<span className="text-danger">*</span></label>
                          <Field
                            as="textarea"
                            name="address"
                            className="form-control mb-3"
                            rows="3"
                            placeholder="Enter full address of company."
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">City:<span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="city"
                            className="form-control mb-3"
                            placeholder="Enter City"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Facebook:</label>
                          <Field
                            type="text"
                            name="facebook"
                            className="form-control mb-3"
                            placeholder="Enter Facebook URL"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Twitter:</label>
                          <Field
                            type="text"
                            name="twitter"
                            className="form-control mb-3"
                            placeholder="Enter Twitter URL"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">LinkedIn:</label>
                          <Field
                            type="text"
                            name="linkedin"
                            className="form-control mb-3"
                            placeholder="Enter LinkedIn URL"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Instagram:</label>
                          <Field
                            type="text"
                            name="instagram"
                            className="form-control mb-3"
                            placeholder="Enter Instagram URL"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">WhatsApp:</label>
                          <Field
                            type="text"
                            name="whatsapp"
                            className="form-control mb-3"
                            placeholder="Enter WhatsApp Number/URL"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Pinterest:</label>
                          <Field
                            type="text"
                            name="pinterest"
                            className="form-control mb-3"
                            placeholder="Enter Pinterest URL"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-full">
                        <div className="form-group">
                          <label className="form-label">Company tagline:<span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="tagline"
                            className="form-control mb-3"
                            rows="3"
                            placeholder="Enter tagline of company."
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">Company Logo:<span className="text-danger">*</span></label>
                          <input
                            type="file"
                            name="logo"
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(event) => {
                              const file = (event.currentTarget as HTMLInputElement).files?.[0] || null;

                              if (file) {
                                const validTypes = ["image/png", "image/jpeg", "image/jpg"];
                                if (validTypes.includes(file.type)) {
                                  setFieldValue("logo", file);
                                } else {
                                  alert("Only JPG, JPEG, and PNG files are allowed.");
                                  event.target.value = "";
                                }
                              }
                            }}
                            className="form-control mb-3"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="primary">
                          Create New Company
                        </Button>
                        <Link to="/companieslist" className="btn btn-danger ms-3">
                          Go Back
                        </Link>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmationModal
        show={showConfirmationModal}
        onHide={() => {
          setShowConfirmationModal(false);
          setShowSuccessModal(true);
          navigate('/companieslist');

        }}
        modalMessage="Company added successfully! Click OK to proceed."
        operationType="OK"
      />
      <NewconfirmationModal
        show={showSuccessModal}
        onHide={() => {
          setShowSuccessModal(false);

        }}
        modalMessage={successMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
      <AllFailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        modalMessage={failureMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
    </Container>
  );
};

export default CompaniesAdd;